import { useReducer, useEffect } from 'react';
const getStateClasses = (fieldStates, fieldName) => {
    const loadingClass = fieldStates.isLoading ? `field-loading` : ``;
    const activeClass = fieldStates.isActive ? `field-active` : `field-inactive`;
    const errorClass = fieldStates.withError
        ? `with-error ${fieldName}-with-error`
        : `without-error ${fieldName}-without-error`;
    const contentClass = fieldStates.withContent ? 'with-content' : 'without-content';
    const disabledClass = fieldStates.isDisabled ? 'field-disabled' : 'field-enabled';
    return `${contentClass} ${activeClass} ${loadingClass} ${disabledClass} ${errorClass}`;
};
const changeState = (states, name, errors, typeValidation, dataValidation) => {
    switch (typeValidation) {
        case 'value':
            states.withContent = dataValidation && dataValidation.value;
            break;
        case 'input-value':
            states.withContent = dataValidation && dataValidation.inputValue;
            break;
        case 'active':
            states.isActive = dataValidation;
            break;
        case 'loading':
            states.isLoading = dataValidation;
            break;
        case 'disabled':
            states.isDisabled = dataValidation;
            break;
        default:
            break;
    }
    states.withError = Boolean(errors && errors[name]);
    return states;
};
const initialFieldValidationSate = {
    classes: '',
    fieldStates: { withError: false, withContent: false, isActive: false, isDisabled: false, isLoading: false },
    rules: {},
    errors: {},
    value: '',
    inputValue: '',
    name: '',
};
const FieldValidationReducer = (state, action) => {
    switch (action.type) {
        case 'state-error':
            return Object.assign(Object.assign({}, state), { fieldStates: Object.assign({}, changeState(state.fieldStates, state.name, state.errors, null, null)) });
        case 'rules':
            return Object.assign(Object.assign({}, state), { rules: action.validationRules });
        case 'errors':
            return Object.assign(Object.assign({}, state), { errors: action.validationErrors, fieldStates: Object.assign({}, changeState(state.fieldStates, state.name, state.errors, null, null)) });
        case 'name':
            return Object.assign(Object.assign({}, state), { name: action.fieldName });
        case 'value':
            return Object.assign(Object.assign({}, state), { value: action.fieldValue, fieldStates: Object.assign({}, changeState(state.fieldStates, state.name, state.errors, 'value', action.fieldValue)) });
        case 'input-value':
            return Object.assign(Object.assign({}, state), { inputValue: action.fieldValue, fieldStates: Object.assign({}, changeState(state.fieldStates, state.name, state.errors, 'inputValue', action.fieldValue)) });
        case 'state-active':
            return Object.assign(Object.assign({}, state), { fieldStates: Object.assign({}, changeState(state.fieldStates, state.name, state.errors, 'active', action.state)) });
        case 'state-disabled':
            return Object.assign(Object.assign({}, state), { fieldStates: Object.assign({}, changeState(state.fieldStates, state.name, state.errors, 'disabled', action.state)) });
        case 'get-classes':
            return Object.assign(Object.assign({}, state), { classes: getStateClasses(action.states, action.name) });
        default:
            return state;
    }
};
export const useFieldValidation = (validations, errors, name, disabled) => {
    const [state, dispatch] = useReducer(FieldValidationReducer, initialFieldValidationSate);
    useEffect(() => {
        dispatch({ type: 'rules', validationRules: validations });
        dispatch({ type: 'name', fieldName: name });
        dispatch({ type: 'state-disabled', state: disabled });
    }, [validations, name, disabled]);
    useEffect(() => {
        dispatch({ type: 'errors', validationErrors: errors });
    }, [errors]);
    useEffect(() => {
        dispatch({ type: 'get-classes', states: state.fieldStates, name });
    }, [state.fieldStates]);
    useEffect(() => {
        dispatch({ type: 'state-error' });
    }, [state.errors]);
    const setValue = value => {
        dispatch({ type: 'value', fieldValue: value });
    };
    const setInputValue = option => {
        dispatch({ type: 'input-value', fieldValue: option === null || option === void 0 ? void 0 : option.value });
    };
    const setActive = (a) => {
        dispatch({ type: 'state-active', state: a });
    };
    return Object.assign(Object.assign({}, state), { setValue, setInputValue, setActive });
};
